<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import { __ } from '@/js/stores/expressions';
    import { ChevronDownIcon } from '@lucide/vue';

    defineProps<{ label: string }>();

    const open = ref<boolean>(false);

    const slotContainer = ref<HTMLElement | null>(null);

    onMounted(() => {
        const el = slotContainer.value?.querySelector('[data-selected="true"]');
        if (el) {
            open.value = true;
        }
    });
</script>
<template>
    <div>
        <button
            class="flex group text-start justify-between w-full py-2 px-3 text-body custom-focus rounded-sm cursor-pointer"
            :aria-label="`${open ? __('close') : __('open')}-${label}`"
            :aria-expanded="open"
            @click="open = !open"
        >
            {{ label }}
            <div class="flex items-center group-hover:bg-gray-lightest p-0.5 -m-0.5 rounded-sm">
                <span class="size-5">
                    <ChevronDownIcon :class="open && 'rotate-180'" />
                </span>
            </div>
        </button>
        <div
            ref="slotContainer"
            :class="open ? 'block' : 'hidden'"
            class="pl-5 pt-1 pb-1 flex flex-col gap-1"
        >
            <slot />
        </div>
    </div>
</template>
